export const profileFields = [
  'uuid',
  'first_name',
  'middle_name',
  'last_name',
  'suffix',
  'social_security_number',
  'id',
]

export const mapqRowSpan = {
  retrieve_existing: 'row-span-2',
  upgrade_add_spouse: 'row-span-3',
  unmerge: 'row-span-4',
}

export const defaultMailingAddress = {
  street: '',
  unit_number: '',
  external_id: undefined,
  uuid: undefined,
  city: '',
  state: '',
  zip_code: '',
}

export const groups = [
  { name: 'sales', color: '#4472c4d9', label: 'Sales', nickname: 'HEO' },
  { name: 'processing', color: '#7030a0d9', label: 'Processing', nickname: 'TS' },
  { name: 'underwriting', color: '#FF0000', label: 'Underwriting', nickname: 'VA' },
  { name: 'uam-review', color: '#70ad47d9', label: 'UAM', nickname: 'PM' },
  { name: 'uw-review', color: '#70ad47d9', label: 'UW', nickname: 'UW' },
  { name: 'closing', color: '#ff7f27d9', label: 'Closing', nickname: 'CL' },
  { name: 'post-closing', color: '#22e64cd9', label: 'Post Closing', nickname: 'PC' },
]

export const allAppraisalReportTypes = [
  '1004',
  '1004D',
  'condo-1073',
  'customer-stated',
  'fnma-1004-single-family',
  'generic',
  'hybrid',
  'ivaluenet-55',
  'multi-1025',
]
